'use client';

import { useState, useEffect } from 'react';

interface ScrollProgressIndicatorProps {
  className?: string;
}

const ScrollProgressIndicator = ({ className = '' }: ScrollProgressIndicatorProps) => {
  const [scrollProgress, setScrollProgress] = useState<number>(0);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      const scrollableHeight = documentHeight - windowHeight;
      const progress = (scrollTop / scrollableHeight) * 100;

      setScrollProgress(Math.min(progress, 100));
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div data-component-id="src/components/common/ScrollProgressIndicator.tsx:30:4" data-component-path="src/components/common/ScrollProgressIndicator.tsx" data-component-line="30" data-component-file="ScrollProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
      className={`fixed top-0 left-0 right-0 h-1 bg-muted z-[90] ${className}`}
      role="progressbar"
      aria-valuenow={Math.round(scrollProgress)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Page scroll progress"
    >
      <div data-component-id="src/components/common/ScrollProgressIndicator.tsx:38:6" data-component-path="src/components/common/ScrollProgressIndicator.tsx" data-component-line="38" data-component-file="ScrollProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-full%20bg-gradient-to-r%20from-primary%20via-secondary%20to-primary%20transition-all%20duration-250%20ease-out%22%7D"
        className="h-full bg-gradient-to-r from-primary via-secondary to-primary transition-all duration-250 ease-out"
        style={{ width: `${scrollProgress}%` }}
      />
    </div>
  );
};

export default ScrollProgressIndicator;